import "./buttons.scss";

import ICON from "../icons/trashCanIcon.svg";

export const TrashButton = (props: {
  onClick: () => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button trash"
      onClick={props.onClick}
    >
      <img src={ICON} alt="" />
    </button>
  );
};
